import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminDashboard from "./components/AdminDashboard";
import Home from "./components/Home";
import StreamPage from "./components/StreamPage";

// Import the Components

export default function Paths() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/admin" element={<AdminDashboard />} />
      <Route exact path="/live" element={<StreamPage />} />
    </Routes>
  );
}
